import { render } from "./InvoiceDetailInput.vue?vue&type=template&id=a56c7634"
import script from "./InvoiceDetailInput.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__